<template>
  <div>
    <header id="page-topbar">
      <div class="navbar-header headerPage d-flex justify-content-between" style="height: 80px; padding: 24px;">
          <div class="btn-info-logo" @click="$router.push({ path: `/homepage` })">
            <img src="@/assets/images/nextshop-logo.svg" alt="next360" />
          </div>
          <div class="headerPage-title">
            <b class="fz-20">Điều chỉnh gói sử dụng</b>
          </div>
          <button type="button" class="btn btn-mb btn-primary" @click="merchantPlanConfigsUpdate"><span> Tiếp tục sử dụng </span></button>
      </div>
    </header>
    <div class="page-content">
      <div class="box bg-pos">
        <div>Bạn đã thay đổi sang gói NextShop mới</div>
        <div class="box-bdt">
          <div class="text-primary title-pakage">{{dataPackage.name}}</div>
          <div class="num-branch">
            Tối đa {{dataPackage.maxLocations}} chi nhánh,
            <span v-if="dataPackage.maxAliasUsers == -1">không giới hạn số nhân viên</span>
            <span v-else>{{dataPackage.maxAliasUsers}} tài khoản nhân viên</span>
          </div>
        </div>
        <div class="text-start">Bắt đầu từ {{timeFormatDate(dataPackage.startTime)}} tới {{timeFormatDate(dataPackage.endTime)}}</div>
      </div>
      <div class="box">
        <div class="title-active">Chọn chi nhánh hoạt động</div>
        <div class="title-mess">
            Bạn đã đăng ký NextShop với gói <b>{{dataPackage.name}}</b>.<br/>
            Vui lòng chọn tối đa <b>{{dataPackage.maxLocations}}</b> trong số các chi nhánh hiện có để tiếp tục hoạt động.
        </div>
        <div class="box-branch">
          <div class="d-flex item-branch" v-for="(location, index) in listLocation" :key="index">
            <input type="checkbox"
              @change="checkBoxLocation(location)"
              :checked="isChecked(location.coLocationId)"
              :disabled="(dataPackage.maxLocations <= arrLocation.length && !arrLocation.includes(location.coLocationId)) || dataPackage.maxLocations >= listLocation.length"
            />
            <p>
              <b>{{location.name}}</b> <br/>
              {{location.address}}
            </p>
          </div>
        </div>
        <div>Đã chọn {{arrLocation.length}}/{{dataPackage.maxLocations}} chi nhánh</div>
      </div>
      <div class="box">
        <div class="title-active">Chọn tài khoản</div>
        <div class="title-mess">
          Chọn tài khoản được sử dụng NextShop.<br/>
          (với gói không có quản lý nhân viên, sẽ không có tài khoản nào được chọn)
        </div>
        <div class="box-user-employee" v-if="dataEmployee.length > 0">
          <div class="item-branch ext">
            <div class="row">
              <div class="col-md-6" v-for="(employee, index) in dataEmployee" :key="index">
                <div class="item d-flex">
                  <input type="checkbox"
                    @change="checkBoxEmployee(employee)"
                    :checked="isCheckedEmployee(employee.id)"
                    v-if="dataPackage.maxAliasUsers == -1"
                  >
                  <input type="checkbox"
                    v-else
                    @change="checkBoxEmployee(employee)"
                    :checked="isCheckedEmployee(employee.id)"
                    :disabled="((dataPackage.maxAliasUsers <= arrEmployee.length) && !arrEmployee.includes(employee.id))"
                  >
                  <div class="thumb">
                    <img src="@/assets/images/user-default.png" />
                  </div>
                  <p>
                    <b>{{employee.name}}</b><br/>
                    {{employee.email}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-user-employee" v-else>
          <div class="boxEmpty">
            Chưa có tài khoản nhân viên nào được tạo.
          </div>
        </div>
      </div>
    </div>
    <div class="box-loading" v-show="loading">
      <div class="loading">
        <b-spinner variant="primary" label="Loading..." />
      </div>
    </div>
  </div>
</template>
<script>
  import { PackageService } from "@/services/nextshop/package.service";
  import getListLocation from "@/mixins/location/getListLocation"
  import { EmployeeService } from '@/services/nextshop/employee.service'
  import Swal from "sweetalert2"
  import { removeStorageItem } from '@/utils/auth'
  import { AuthService } from '../../services/auth.service'

  export default {
    name: "package-select-v2",
    
    mixins: [getListLocation],

    data() {
      return {
        loading: false,
        listLocation: false,
        arrLocation:[],
        dataPackage: {},
        dataEmployee:[],
        arrEmployee:[],
        checkConfig:null
      };
    },
  
    async created() {
      await this.merchantPlanConfigs()
      await this.getListEmployee()
    },
    methods: {
      async merchantPlanConfigs() {
        try {
          this.loading = true
          const response = await PackageService.merchantPlanConfigs()
          if (response.success) {
            if(response.data.plan == null || response.data.plan == ''){
              removeStorageItem('locationName')
              AuthService.packageBackHome()
            }else{
              this.listLocation = await this.getListLocation()
              this.dataPackage = response.data.plan
              this.checkConfig = response.data.config
            }
          }
          this.loading = false
        } catch (error) {
          console.log(error);
        }
      },
      async getListEmployee() {
        const params = {
          limit: 30000,
          page: 1,
          sort: "DESC",
          sortBy: 'createdAt',
          userType: 'employee',
          status:	'ACTIVE',
          locations: null
        }
        const response = await EmployeeService.getListEmployee(params)
        if (response.success) {
          this.dataEmployee = response.data
        }
      },
      async merchantPlanConfigsUpdate() {
        try {
          this.loading = true
          const params = {
            coAliasUserIds: this.arrEmployee,
            coLocationIds: this.arrLocation
          }
         
          if(this.arrLocation.length < this.dataPackage.maxLocations && this.listLocation.length >= this.dataPackage.maxLocations){
            Swal.fire({
              icon: "warning",
              title: "Thất bại",
              text: 'Vui lòng chọn đủ các chi nhánh và thử lại',
              confirmButtonText: "Xác nhận",
            })
            this.loading = false
            return false
          }
          
          let response = {}
          if(this.checkConfig != null){
            response = await PackageService.merchantPlanConfigsUpdate(params)
          }else{
            response = await PackageService.merchantPlanConfigsCreate(params)
          }
         
          if (response.success) {
            this.$router.push({ path: `/dashboard` })
          }
          this.loading = false
        } catch (error) {
          console.log(error)
        }
      },
      isChecked(id) {
        if(this.checkConfig != null){
          if(this.listLocation.length <= this.dataPackage.maxLocations ){
              if(!this.arrLocation.includes(id)){
                this.arrLocation.push(id)
                return true
              }else{
                return true
              }
          }
        }
      },
      async checkBoxLocation(item) {
        if(this.dataPackage.maxLocations >= this.arrLocation.length){
          const exists = this.arrLocation.includes(item.coLocationId)
          if (exists) {
            this.arrLocation = this.arrLocation.filter((c) => {return c !== item.coLocationId})
          }else{
            this.arrLocation.push(item.coLocationId)
          }
        }
      },
      isCheckedEmployee(id) {
        if(this.checkConfig != null){
          if(this.dataEmployee.length <= this.dataPackage.maxAliasUsers ){
              if(!this.arrEmployee.includes(id)){
                this.arrEmployee.push(id)
                return true
              }
          }
        }
      },
      async checkBoxEmployee(item) {
        if(this.dataPackage.maxAliasUsers >= this.arrEmployee.length){
          const exists = this.arrEmployee.includes(item.id);
          if (exists) {
            this.arrEmployee = this.arrEmployee.filter((c) => {return c !== item.id})
          } else {
            this.arrEmployee.push(item.id)
          }
        }
      },
    },
  };
  </script>

<style scoped>
  .box {
  width: 100%;
  margin: auto;
  max-width: 800px;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 20px;
  background: #fff;
  box-shadow: 0px 0px 12px -4px rgba(0, 0, 0, 0.08), 0px 8px 12px -8px rgba(0, 0, 0, 0.16);
}
.box-bdt{
  border-top: 2px solid #ddd;
  display: inline-block;
  margin-top: 10px;
  padding-top: 10px;
  min-width: 33%;
}
.title-pakage {
  font-size: 18px;
  font-weight: bold;
}
.num-branch{
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
  display: inline-block;
  width: 100%;
}
.text-start{
  color:#808890
}
.title-active{
  color: #222;
  font-size: 18px;
  font-weight: bold;
}
.title-mess {
  background: #FFF9EC;
  padding: 10px;
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.item-branch span{
  color: #808890;
}
.item-branch input {
  margin-right: 10px;
  height: 20px;
  position: relative;
  top: 12px;
}
.item-branch {
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
}
.item-branch:last-child{
  border-bottom: none;
}
.thumb{
  width: 35px;
  height: 35px;
  overflow: hidden;
  border-radius: 100%;
  background: #fafafa;
  margin: 3px 8px 0 0;
}
.item-branch.ext{
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
}
.item-branch.ext:last-child{
  border-bottom: none;
}
.box-branch {
  max-height: 500px;
  overflow-y: scroll;
  display: inline-block;
  width: 100%;
}
.box-user-employee{
  max-height: 500px;
  overflow-y: scroll;
  display: inline-block;
  width: 100%;
}
.boxEmpty{
  text-align: center;
  color: #808890;
  padding: 50px;
}
</style>
